import React from "react";
import { API_SIDEBAR, SectionId } from "./SidebarConfig";

interface ApiSidebarProps {
  active: SectionId;
  onChange: (id: SectionId) => void;
}

export const ApiSidebar: React.FC<ApiSidebarProps> = ({
  active,
  onChange,
}) => {
  return (
    <aside
      className=" sticky w-[270px] shrink-0 lg:max-h-[calc(100vh-120px)] overflow-y-auto rounded-3xl lg:border lg:border-white/[0.08]
    lg:bg-white/[0.04] backdrop-blur-[6px] px-5 py-10">
      <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-white/60">
        Reference
      </p>

      <nav className="space-y-4">
        {API_SIDEBAR.map((group) => (
          <div key={group.group}>
            <div className="relative">
              {group.items.map((item) => {
                const isActive = item.id && active === item.id;

                if (item.isParent) {
                  return (
                    <div key={item.label} className="relative">
                      <div className="px-4 py-2 text-sm text-white">
                        {item.label}
                      </div>
                    </div>
                  );
                }

                return (
                  <button
                    key={item.id ?? item.label}
                    onClick={() => item.id && onChange(item.id)}
                    className={`
                relative w-full text-left text-sm transition-all

                ${item.isChild ? "pl-8 pr-4 py-2" : "px-4 py-3"}

                ${isActive
                        ? "rounded-lg border-l-2 border-web-primary bg-web-primary/10 text-web-primary"
                        : "border-l-2 border-transparent text-white/70 hover:text-white"
                      }
              `}
                  >
                    {item.isChild && (
                      <span className="absolute left-3 top-1/2 h-1 w-1 -translate-y-1/2 rounded-full bg-web-primary" />
                    )}

                    {item.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  );
};